export const pipeSaperatedString = (string, isLabel) => {
  console.log(string);
  console.log("Called export const pipeSaperatedString")
  if (string){
  const arr = string && string.split(',');
  !isLabel && arr.shift();

  const list = arr && arr.map(item => {
    const splitCell = item.split('|');
    if (splitCell[1])
      return { value: splitCell[0], label: splitCell[1] };
  });

  return list;
}
else
return []
};

export const usDateString = (date) => {
  const usDate = date.toLocaleDateString(
    'en-US',
    { year: 'numeric', month: '2-digit', day: '2-digit' },
  );

  return usDate;
};

export const isExternalUrl = (url) => {
  if (/^https?:\/\//.test(url) || /^http?:\/\//.test(url)) {
    const parser = document.createElement('a');
    parser.href = url;

    return parser;
  }
  return false;
};

export const addOverflowClass = () => {
  document.body.classList.add('hide-overflow');
};

export const removeOverflowClass = () => {
  document.body.classList.remove('hide-overflow');
};